/**
 * OSP Index API constants (headers, environment, base URLs).
 *
 * @source @open-social-protocol/osp-api-index-types
 *   - src/constant.ts
 *   - src/environments.ts
 */

/** OSP Index API request header names */
export const HEADERS = {
  APP_ID: "OS-App-Id",
  CHAIN_ID: "OS-Chain-Id",
  GUEST_ID_MARKETING: "OS-Guest-Id-Marketing",
  /** 域名/App 升级后的品牌标识，与旧 OSP 产品区分 */
  REG_BRAND: "OS-Reg-Brand",
} as const;

/** `OS-Reg-Brand` 固定值（全端一致） */
export const OSP_REG_BRAND = "edwealth";

/** ospprotocol Index 后端请求应带的品牌头（Chat/perplexica 不要带 —— CORS 未放行） */
export function ospRegBrandHeaders(): Record<string, string> {
  return { [HEADERS.REG_BRAND]: OSP_REG_BRAND };
}

export enum Environment {
  local = "local",
  dev = "dev",
  alpha = "alpha",
  beta = "beta",
  pre = "pre",
  prod = "prod",
}

/** Index API root per env (trailing path is appended by callers, e.g. `/profiles/...`) */
export const EnvIndexUrl: { [name: string]: string } = {
  local: "https://api.dev.ospprotocol.xyz/v2",
  dev: "https://api.dev.ospprotocol.xyz/v2",
  alpha: "https://api.alpha.ospprotocol.xyz/v2",
  beta: "https://api.beta.ospprotocol.xyz/v2",
  pre: "https://api.opensocial.fun/v2",
  prod: "https://api.edwealth.ai/v2",
};

/** Fallback when `NEXT_PUBLIC_APP_ID` is unset (matches SSR helper historical `|| "100"`) */
export const DEFAULT_OSP_APP_ID = "100";

/** SDK `TOKEN_EXP_TIME` — id_token cache buffer before re-fetching (30 minutes). */
export const ID_TOKEN_CACHE_BUFFER_MS = 1800 * 1000;

/**
 * Index API root for the given OSP environment (same mapping as SDK `AuthModule` → `indexClient.baseUrl`).
 */
export function getEnvIndexBaseUrl(environment: Environment | string): string {
  return EnvIndexUrl[environment] ?? EnvIndexUrl[Environment.dev];
}
